<!-- <template>
    <div>
        <app-new-breadcrumb :id="this.id"
            :routesName="[this.$t('newsRouteName'), this.$t('infographicsRouteName'), this.$t('oldCurrencySavingsRouteName')]"></app-new-breadcrumb>
        <div class="main-part" id="main-part">
            <div id="news-details" class="panel rounded news-details">
                <div class="news-detail">
                    <h1 class="news-title">{{ item.title }}</h1>
                    <p class="news-datetime">{{ item.dateTime | moment($t("dateFormat")) }}</p>
                    <div class="news-img" v-if="item.url != null"><img :src="item.url" :alt="item.title" /></div>
                    <div v-show="isMediaPanelVisible">
                        <div class="row pl-2 pr-3 mt-2">
                            <app-media v-for="(media, index) in media" v-bind:key="media.id" v-bind:media="media"
                                v-on:click.native="previewMedia(index)"></app-media>
                        </div>
                    </div>
                    <div class="news-text" v-html="htmlContent"></div>
                </div>

                <app-media-gallery ref="mediaPreviewer" v-bind:media="media" v-bind:show-caption="true"
                    v-bind:show-light-box="false"></app-media-gallery>
                <div class="news-details-tags">
                    <hr v-if="isTagsPanelVisible" />
                    <div v-if="isTagsPanelVisible">
                        <app-content-tags v-bind:tags="getContentTags"></app-content-tags>
                    </div>
                </div>

                <hr v-if="this.hasContentChild && isInfographicsContent()" />
                <div v-if="this.hasContentChild && isInfographicsContent()" class="infographic-all-documents">
                    <h1 class="news-title">{{ $t("documents") }}</h1>
                    <div class="news-list-text" v-for="item in getChildrenByParentId(id, true)" :key="item.id">
                        <a v-bind:href="item.url" target="_blank" class="btn btn-block"><i
                                class="fa fa-file-pdf-o ml-1 mr-1"></i>{{ item.title }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
import ContentTags from "./ContentTags.vue"
import Breadcrumb from "../common/Breadcrumb.vue";
import Media from "../media/Media.vue"
import MediaGallery from "vue-it-bigger"

export default {
    props: ["id"],
    name: "AppNewsContentNew",
    data() {
        return {
            item: null,
            htmlContent: "",
            breadcrumbItems: [],
            menuDetailsCorrectIds: [8, 10, 11],
            hasContentChild: false,
            media: []
        }
    },
    components: {
        appContentTags: ContentTags,
        appNewBreadcrumb: Breadcrumb,
        appMedia: Media,
        appMediaGallery: MediaGallery,
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.media = this.getContentMedia(this.id);
            this.fetchContentById(this.id).then((contentResposnse) => {
                this.htmlContent = contentResposnse.content;
            });
        },
        previewMedia(index) {
            this.$refs.mediaPreviewer.showImage(index);
        },
        isInfographicsContent() {
            let parsedTags = [];

            try {
                parsedTags = JSON.parse(this.item.tags);
            } catch (e) {
                console.warn('Failed to parse tags:', this.item.tags);
            }
            const isInfographic = Array.isArray(parsedTags) && parsedTags.some(t => t.tagId === 1069);
            return isInfographic;
        }
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getHighlightedNews", "getChildrenByParentId", "hasDocContentChildren", "getContentMedia"]),
        getContentTags() {
            return this.item.tags ? JSON.parse(this.item.tags) : [];
        },
        isTagsPanelVisible() {
            return this.item.tags;
        },
        isMediaPanelVisible() {
            return this.media.length > 0;
        },
    },
    created() {
        this.item = this.getContentById(this.id);
        this.hasContentChild = this.hasDocContentChildren(this.id);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
        '$route.params.id'() {
            this.item = this.getContentById(this.id);
            this.loadData();
        }
    },
    updated() {
        var el = this.$el;
        el.scrollIntoView();
    }
}
</script>

<style scoped>
.main-part {
    display: flex;
    padding: 10px 7% 2% 7%;
}

.panel {
    padding: 3% 5%;
    background-color: var(--secondary-color);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
}

.news-details {
    width: 100%;
    padding: 15px 2%;
    align-items: start;
}

.news-details-tags {
    width: 100%;
    padding: 0%;

}

.news-list-text a {
    text-decoration: none;
    color: var(--main-color);
}

.news-img {
    width: 60%;
    max-width: 100%;
    height: 55vh;
    overflow: hidden;
    margin-left: 20%;
    margin-right: 60%;
}

.news-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.news-title {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 10px;
    color: var(--main-color);
    font-weight: 500;
}

.news-text {
    font-size: 18px;
    line-height: 18px;
    margin-top: 10px;
    text-align: justify;
}

.news-datetime {
    width: 100%;
    font-size: .95rem;
    line-height: 1rem;
    color: #757575;
    margin-bottom: 10px;
}

.news-list-text {
    width: 100%;
    padding: 5px;
    color: var(--main-color);
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    text-align: justify;
    border: 1px solid var(--secondary-color);
    margin-bottom: 5px;
    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, .15);
    margin-top: 5px;
}

.news-list-text:hover {
    background-color: var(--secondary-color);
}

.top-news a {
    text-decoration: none;
}

.top-news a:hover {
    text-decoration: none;
}

@media only screen and (max-width: 1200px) {
    .panel {
        margin-left: 0%;
        margin-right: 0%;
    }

    .news-details {
        width: 100%;
        align-items: start;
    }

}

@media only screen and (max-width: 992px) {
    .main-part {
        flex-direction: column-reverse;
    }

    .top-news {
        width: 100%;
    }

    .news-details {
        width: 100%;
    }
}

@media only screen and (max-width: 768px) {
    .news-img {
        width: 100%;
        max-width: 100%;
        height: 55vh;
        overflow: hidden;
        margin-left: 0%;
        margin-right: 0%;
    }

    .news-img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
 -->


<template>
    <div>
        <app-new-breadcrumb :id="this.id"
            :routesName="[this.$t('newsRouteName'), this.$t('infographicsRouteName'), this.$t('oldCurrencySavingsRouteName')]"></app-new-breadcrumb>
        <div class="main-part" id="main-part">
            <div class="panel rounded content two-col">
                <div id="news-details" class="news-details">
                    <div class="news-detail">
                        <h1 class="news-title">{{ item.title }}</h1>
                        <p class="news-datetime">{{ item.dateTime | moment($t("dateFormat")) }}</p>
                        <div class="news-img" v-if="item.url != null"><img :src="item.url" :alt="item.title" /></div>
                        <div v-show="isMediaPanelVisible">
                            <div class="media-preview">
                                <template v-for="(m, index) in media.slice(0, 5)">
                                    <app-media v-if="index < 4" :key="m.id" :media="m"
                                        @click.native="previewMedia(index)"></app-media>
                                    <div v-else class="media-placeholder last-media" @click="previewMedia(index)">
                                        <img :src="m.thumb" :alt="m.alt" />
                                        <div class="overlay-blur">
                                            <span class="overlay-text">+{{ media.length - 5 }}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="news-text" v-html="htmlContent"></div>
                    </div>
                    <app-media-gallery ref="mediaPreviewer" v-bind:media="media" v-bind:show-caption="true"
                        v-bind:show-light-box="false"></app-media-gallery>
                    <div class="news-details-tags">
                        <hr v-if="isTagsPanelVisible" />
                        <div v-if="isTagsPanelVisible">
                            <app-content-tags v-bind:tags="getContentTags"></app-content-tags>
                        </div>
                    </div>

                    <hr v-if="this.hasContentChild && isInfographicsContent()" />
                    <div v-if="this.hasContentChild && isInfographicsContent()" class="infographic-all-documents">
                        <h1 class="news-title">{{ $t("documents") }}</h1>
                        <div class="news-list-text" v-for="item in getChildrenByParentId(id, true)" :key="item.id">
                            <a v-bind:href="item.url" target="_blank" class="btn btn-block"><i
                                    class="fa fa-file-pdf-o ml-1 mr-1"></i>{{
                                        item.title }}</a>
                        </div>
                    </div>
                </div>
                <aside class="latest-news">
                    <!-- <div v-if="getHighlightedNewsSide(id).length" class="last-news-container">
                        <h3 class="sidebar-title">{{ $t('latestNews') }}</h3>
                        <div class="last-news-list">
                            <router-link v-for="news in getHighlightedNewsSide(id)" :key="news.id"
                                :to="{ name: 'news-content', params: { id: news.id } }" class="news-item">
                                <h4 class="news-item-title">{{ news.title }}</h4>
                                <p class="news-item-date">{{ news.dateTime | moment($t('dateFormat')) }}</p>
                            </router-link>
                        </div>
                    </div> -->
                    <div v-if="isInfographicsContent() && getHighlightedInfographicsSide(id).length"
                        class="last-news-container">
                        <h3 class="sidebar-title">{{ $t('latestInfographics') }}</h3>
                        <div class="last-news-list">
                            <router-link v-for="inf in getHighlightedInfographicsSide(id)" :key="inf.id"
                                :to="{ name: 'news-content', params: { id: inf.id } }" class="news-item">
                                <h4 class="news-item-title">{{ inf.title }}</h4>
                                <p class="news-item-date">{{ inf.dateTime | moment($t('dateFormat')) }}</p>
                            </router-link>
                        </div>
                    </div>
                    <div v-else-if="getHighlightedNewsSide(id).length" class="last-news-container">
                        <h3 class="sidebar-title">{{ $t('latestNews') }}</h3>
                        <div class="last-news-list">
                            <router-link v-for="news in getHighlightedNewsSide(id)" :key="news.id"
                                :to="{ name: 'news-content', params: { id: news.id } }" class="news-item">
                                <h4 class="news-item-title">{{ news.title }}</h4>
                                <p class="news-item-date">{{ news.dateTime | moment($t('dateFormat')) }}</p>
                            </router-link>
                        </div>
                    </div>
                </aside>
            </div>

        </div>
    </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
import ContentTags from "./ContentTags.vue"
import Breadcrumb from "../common/Breadcrumb.vue";
import Media from "../media/Media.vue"
import MediaGallery from "vue-it-bigger"

export default {
    props: ["id"],
    name: "AppNewsContentNew",
    data() {
        return {
            item: null,
            htmlContent: "",
            breadcrumbItems: [],
            menuDetailsCorrectIds: [8, 10, 11],
            hasContentChild: false,
            media: [],
        }
    },
    components: {
        appContentTags: ContentTags,
        appNewBreadcrumb: Breadcrumb,
        appMedia: Media,
        appMediaGallery: MediaGallery,
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.media = this.getContentMedia(this.id);
            this.fetchContentById(this.id).then((contentResposnse) => {
                this.htmlContent = contentResposnse.content;
            });
        },
        previewMedia(index) {
            this.$refs.mediaPreviewer.showImage(index);
        },
        isInfographicsContent() {
            let parsedTags = [];

            try {
                parsedTags = JSON.parse(this.item.tags);
            } catch (e) {
                console.warn('Failed to parse tags:', this.item.tags);
            }
            const isInfographic = Array.isArray(parsedTags) && parsedTags.some(t => t.tagId === 1069);
            return isInfographic;
        },
    },
    computed: {
        ...mapGetters(["getContentById", "getSelectedLanguage", "getChildrenByParentId", "hasDocContentChildren", "getContentMedia", "getHighlightedNews", "getHighlightedNewsSide", "getHighlightedInfographicsSide"]),
        getContentTags() {
            return this.item.tags ? JSON.parse(this.item.tags) : [];
        },
        isTagsPanelVisible() {
            return this.item.tags;
        },
        isMediaPanelVisible() {
            // return this.media.length > 0;
            return this.media.length > 1; /*New ako ima vise od jedne slike da ima preview */
        },

    },
    created() {
        this.item = this.getContentById(this.id);
        this.hasContentChild = this.hasDocContentChildren(this.id);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
        '$route.params.id'() {
            this.item = this.getContentById(this.id);
            this.loadData();
        }
    },
    updated() {
        const el = this.$el;
        if (el && typeof el.scrollIntoView === "function") {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }
}
</script>

<style scoped>
.main-part {
    display: flex;
    padding: 10px 7% 2% 7%;
}

.panel {
    background-color: var(--secondary-color);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
}

.news-details {
    width: 100%;
    padding: 0;
    /* max-width: 850px; */
    margin: 0 auto;
}

.news-detail {
    max-width: 100%;
    width: 100%;
}

.news-details-tags {
    padding: 0%;
}

.news-list-text a {
    text-decoration: none;
    color: var(--main-color);
}

.news-img {
    max-width: 100%;
    height: 60vh;
    overflow: hidden;
}

.news-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.news-title {
    font-size: clamp(1.9rem, 2.6vw, 2.15rem);
    line-height: 1.35;
    margin-bottom: 12px;
    color: var(--main-color);
    font-weight: 700;
}

.news-text {
    font-size: clamp(1.15rem, 1.2vw, 1.1875rem);
    line-height: 1.65;
    margin-top: 12px;
    text-align: justify;
    color: #333;
}

.news-list-text {
    width: 100%;
    padding: 5px;
    color: var(--main-color);
    font-size: 18px;
    line-height: 1.5;
    font-weight: 400;
    text-align: left;
    border: 1px solid var(--secondary-color);
    margin-bottom: 5px;
    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, .15);
    margin-top: 5px;
}

.news-list-text:hover {
    background-color: var(--secondary-color);
}

.top-news a {
    text-decoration: none;
}

.top-news a:hover {
    text-decoration: none;
}

.media-preview {
    /* padding: 0 !important; */
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(5, 1fr);
    width: 100%;
    max-width: 100%;
    margin-top: 8px;
}

.last-media {
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.last-media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(1px) brightness(70%);
    transform: scale(1.05);
}

.overlay-blur {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
}

.overlay-text {
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
}

.panel.two-col {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 32px;
    padding: 32px;
    background-color: var(--secondary-color);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
}

.sidebar-title {
    color: #888;
    font-size: 0.875rem;
    line-height: 1.3;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.06);
}

.latest-news {
    min-width: 0;
}

.last-news-container {
    position: sticky;
    top: 20px;
    padding: 24px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.last-news-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.news-item {
    display: block;
    text-decoration: none;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;
}

.news-item:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.news-item-title {
    font-size: clamp(1.05rem, 1.2vw, 1.125rem);
    /* ≈ 15–16px */
    line-height: 1.4;
    color: var(--main-color);
    font-weight: 400;

}

.news-item-date,
.news-datetime {
    font-size: 0.95rem;
    line-height: 1.25;
    color: #888;
    margin-bottom: 12px;
}

@media only screen and (max-width: 1200px) {
    .panel.two-col {
        gap: 32px;
        padding: 24px;
        display: flex;
    }

    .news-details {
        max-width: 100%;
    }

    .panel {
        margin-left: 0%;
        margin-right: 0%;
    }

    .news-details {
        width: 100%;
        align-items: start;
    }

    .latest-news {
        display: none;
    }
}

@media only screen and (max-width: 992px) {
    .panel.two-col {
        grid-template-columns: 1fr;
        gap: 32px;
    }

    /* .latest-news {
        order: 1;
    } */

    /* .last-news-container {
        position: static;
        background: transparent;
        border: none;
        padding: 0;
    }

    .last-news-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 16px;
    } */

    .news-item {
        padding: 16px;
        background: rgba(0, 0, 0, 0.02);
        border-radius: 6px;
        border: 1px solid rgba(0, 0, 0, 0.06);
    }

    .news-item-date {
        margin-bottom: 0;
    }

    .news-item:last-child {
        padding: 16px;
    }
}

@media only screen and (max-width: 768px) {
    .main-part {
        padding: 10px 4% 2% 4%;
    }

    .panel.two-col {
        padding: 16px;
    }

    .news-img {
        height: 45vh;
        margin: 16px 0;
    }

    /* .last-news-list {
        grid-template-columns: 1fr;
    } */

    .media-preview {
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }
}
</style>